export default __webpack_public_path__ + "static/media/Strugani 15.f77cb999.jpg";